<template>
  <div class="mt-2">
    <Header></Header>
    <Tabla/>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
export default {
  name: 'verSolicitudes',
  components: {
    Tabla: defineAsyncComponent(
      () => import('./componentsSolicitudes/Tabla.vue')
    ),
    Header: defineAsyncComponent(
      () => import('./componentsSolicitudes/Header.vue')
    )
  }
}
</script>
<style scoped>

</style>
